import React, { useState } from 'react';

import { useEventListener } from '/imports/ui/hooks/useEventListener.js';
import { UiState } from '/imports/utils/UiState';
import type { ColorScheme } from './ColorScheme';
import { ColorSchemeC } from './ColorScheme';

const persistedColorScheme = UiState.valueProp('colorScheme', ColorSchemeC);

export const usePreferredColorScheme = (): [ColorScheme, (_: ColorScheme) => void] => {
  const query = React.useRef(window.matchMedia(`(prefers-color-scheme: dark)`));
  const [colorScheme, setColorScheme] = useState(() => {
    const persisted = persistedColorScheme.get();
    if (persisted) return persisted;
    const scheme = query.current.matches ? 'dark' : 'light';
    persistedColorScheme.set(scheme);
    return scheme;
  });

  const updateColorScheme = (scheme: ColorScheme) => {
    setColorScheme(scheme);
    persistedColorScheme.set(scheme);
  };

  useEventListener(query.current)('change', ({ matches }) =>
    updateColorScheme(matches ? 'dark' : 'light'),
  );

  return [colorScheme, updateColorScheme];
};
